import { c as y } from "./contentful-a9b11b75.js";
import { g as s } from "./@firebase-868b0e52.js";
import { f as C } from "./useAccount-8a1c7225.js";
async function h(r, o, c, l, i) {
  var a, t;
  try {
    if (!i || !c)
      return null;
    const e = await C(i);
    if (!e)
      return null;
    const n = s(e, o).asString(), g = s(e, c).asString(), u = s(e, l).asString(), f = (await y.createClient({
      space: n,
      accessToken: g,
      environment: u
    }).getEntries({
      content_type: "genericIdImageDescriptionSlug",
      "fields.slug": r
    })).items[0].fields.image;
    return ((t = (a = f == null ? void 0 : f.fields) == null ? void 0 : a.file) == null ? void 0 : t.url) || null;
  } catch (e) {
    throw console.error("Error fetching entry:", e), e;
  }
}
async function I(r, o, c, l, i, a, t) {
  var e;
  try {
    const n = await C(a);
    if (!n)
      return null;
    const g = s(n, c).asString(), u = s(n, l).asString(), p = s(n, i).asString(), m = await y.createClient({
      space: g,
      accessToken: u,
      environment: p
    }).getEntries({
      content_type: o,
      ...r
    });
    return (t ? m.items : (e = m.items[0]) == null ? void 0 : e.fields) || null;
  } catch (n) {
    return console.error("Error fetching entry:", n), n || null;
  }
}
async function v(r, o, c, l, i, a) {
  try {
    const t = await C(a);
    if (!t)
      return null;
    const e = s(t, c).asString(), n = s(t, l).asString(), g = s(t, i).asString();
    return await y.createClient({
      space: e,
      accessToken: n,
      environment: g
    }).getEntries({
      content_type: o,
      ...r
    }) || null;
  } catch (t) {
    return console.error("Error fetching entry:", t), t || null;
  }
}
const _ = (r) => `${r}?fm=jpg&fl=progressive`, b = (r, o = null) => `${r}?fm=webp${o ? "&q=" + o : ""}`;
export {
  I as a,
  v as b,
  b as c,
  h as g,
  _ as p
};
